/**
 * @generated SignedSource<<afeb4725103859aaf7dd38034d4ed291>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ScreenersElementTypeChoices = "AV" | "CM" | "DS" | "DT" | "FL" | "GS" | "MS" | "NM" | "OE" | "RH" | "RK" | "SS" | "VD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UsePreviousAnswers_screener$data = {
  readonly elements: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly answers: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly position: number;
              readonly text: string | null;
            } | null;
          } | null>;
        };
        readonly characteristic: {
          readonly importKey: string;
        } | null;
        readonly id: string;
        readonly text: string | null;
        readonly type: ScreenersElementTypeChoices;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "UsePreviousAnswers_screener";
};
export type UsePreviousAnswers_screener$key = {
  readonly " $data"?: UsePreviousAnswers_screener$data;
  readonly " $fragmentSpreads": FragmentRefs<"UsePreviousAnswers_screener">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UsePreviousAnswers_screener",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ElementNodeConnection",
      "kind": "LinkedField",
      "name": "elements",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ElementNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ElementNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CharacteristicNode",
                  "kind": "LinkedField",
                  "name": "characteristic",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "importKey",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AnswerNodeConnection",
                  "kind": "LinkedField",
                  "name": "answers",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AnswerNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AnswerNode",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "position",
                              "storageKey": null
                            },
                            (v1/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ScreenerNode",
  "abstractKey": null
};
})();

(node as any).hash = "a712a10b8d88b417adde4a1cbcc925cd";

export default node;
